import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import CustomerReview from './CustomerReview.jsx'
import "../../scss/v2/util/customer.scss"

function Customer(props) {

    const { t } = useTranslation();
    const [index, setIndex] = useState(0)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setIndex(index + 1)
        }, 4000)

        return () => clearInterval(intervalId);

    })

    function renderReviews() {
        return (
            <>
                <div className="customer-review-element d-none d-lg-inline-block left-element">
                    <CustomerReview index={index - 1} />
                </div>
                <div className="customer-review-element middle-element">
                    <CustomerReview index={index} middle={true} />
                </div>
                <div className="customer-review-element d-none d-lg-inline-block right-element">
                    <CustomerReview index={index + 1} />
                </div>
            </>
        )
    }

    return (
        <div className="container-fluid customer-review-container">
            <div className="container">
                <div className="col-12 text-center">
                    <h2 className="homepage-review-title">{t('homepage.reviewBlock.title')}</h2>
                </div>
                <div className="col-12 col-lg-6 offset-lg-3 customer-review-inner-container">
                    <button className="customer-review-button minus-button" onClick={() => { setIndex(index + 1) }}><FontAwesomeIcon icon={faAngleUp} /></button>
                    {renderReviews()}
                    <button className="customer-review-button plus-button" onClick={() => { setIndex(index - 1) }}><FontAwesomeIcon icon={faAngleUp} /></button>
                </div>
            </div>
        </div>
    )

}

export default Customer